import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: "firstUserName",
  standalone: true
})
export class FirstUserNamePipe implements PipeTransform {

  transform(users: any): string {
    if (Array.isArray(users)) {
      return users[0]?.name ?? "";
    } else {
      return users?.name ?? "";
    }
  }
}
